import { create } from "zustand";

export interface SignInCopy {
  eyebrow?: string;
  title?: string;
}

export interface LoginModalOptions extends SignInCopy {
  /** false → backdrop clicks are ignored, only the X closes the modal */
  dismissOnBackdrop?: boolean;
}

interface LoginModalState {
  isLoginModalVisible: boolean;
  modalState: string;
  signInCopy: SignInCopy | null;
  dismissOnBackdrop: boolean;
  showLoginModal: (options?: LoginModalOptions) => void;
  hideLoginModal: () => void;
  setModalState: (state: string) => void;
}

// Cria o store com a tipagem
const useLoginModalStore = create<LoginModalState>((set) => ({
  isLoginModalVisible: false,
  modalState: "SignIn",
  signInCopy: null,
  dismissOnBackdrop: true,
  showLoginModal: (options?: LoginModalOptions) =>
    set({
      isLoginModalVisible: true,
      modalState: "SignIn",
      signInCopy: options
        ? { eyebrow: options.eyebrow, title: options.title }
        : null,
      dismissOnBackdrop: options?.dismissOnBackdrop ?? true,
    }),
  hideLoginModal: () =>
    set({
      isLoginModalVisible: false,
      signInCopy: null,
      dismissOnBackdrop: true,
    }),
  setModalState: (state: string) => set({ modalState: state }),
}));

export default useLoginModalStore;
